import { atom } from "jotai";

/**
 * @deprecated This atom is deprecated. Use one of the following atoms instead:
 *
 * Global checks:
 *   - canvasIdAtom: AI page will have no canvas id
 *   - isDraftModeExcludingTemplatesAtom: true if you're on the AI page or blank canvas using AI Co-pilot.
 *   - isDraftModeIncludingTemplatesAtom: true (like ⬆️) but includes template page
 *
 * Node-level checks:
 *   - isDraftOrTemplateNode: true if node is draft or in a template (use this when you want to target AI stuff AND template nodes)
 *   - isDraftNotTemplateNode: true if node is draft but NOT a template node (use this when you want to target AI stuff but NOT template nodes)
 */
export const isAiPageAtom = atom(false);

isAiPageAtom.debugLabel = "isAiPageAtom";
